// extracted by mini-css-extract-plugin
export var circle = "_9p-1";
export var exitConfirmationModal = "_9p-5";
export var iframe = "_9p-0";
export var offline = "_9p-3";
export var online = "_9p-2";
export var workstationSelectError = "_9p-4";